export default "__VITE_ASSET__CA3To_15__"